export function truncateHtml(text: string, maxLength: number): string {
  let length = 0;
  let output = '';
  let inTag = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];

    if (char === '<') {
      inTag = true;
    }

    if (!inTag) {
      length++;
    }

    output += char;

    if (char === '>') {
      inTag = false;
    }

    if (length >= maxLength) {
      break;
    }
  }

  const openedTags = output.match(/<[^\/>][^>]*>/g) || [];
  const closedTags = output.match(/<\/[^>]+>/g) || [];

  if (openedTags.length > closedTags.length) {
    const lastOpenedTag = openedTags[openedTags.length - 1];
    const tagNameMatch = lastOpenedTag.match(/<(\w+)/);
    if (tagNameMatch) {
      const tagName = tagNameMatch[1];
      output += `</${tagName}>`;
    }
  }

  return output + (length >= maxLength ? '...' : '');
}
